import { sharedDictionaryRu } from 'i18n/ru/sharedDictionaryRu';
import { ClientDetailsBillRowDictionary } from 'types/i18n';

export const clientDetailsBillRowDictionaryRu: ClientDetailsBillRowDictionary = {
  primaryAmountText(row) {
    const amountText = sharedDictionaryRu.moneyAmountText(
      row.amount,
      row.amountCurrency || 'USD'
    );

    if (row.type === 'BY_CARD' || row.type === 'CASHLESS') {
      return `+${amountText}`;
    }

    return amountText;
  },
  titleText(row) {
    if (row.type === 'DEBIT') {
      return `Счет и акт №${row.comment}`;
    }

    if (row.type === 'BY_CARD') {
      if (row.comment !== null) {
        return row.comment;
      }

      return `Платеж картой №${row.id}`;
    }

    if (row.type === 'CASHLESS') {
      if (row.comment !== null) {
        return row.comment;
      }

      return `Платеж на р/с №${row.id}`;
    }

    if (row.type === 'REFUND') {
      return row.comment || '';
    }

    return '-';
  },
  statusText(row) {
    if (row.type === 'DEBIT') {
      if (row.payed) {
        return 'Оплачен';
      }

      return 'Не оплачен';
    }

    return '';
  },
  payDebtButtonText: 'Погасить счeт',
  editRefundButtonText: 'Изменить',

  payDebitConfirmationDialog: {
    title: 'Погашение счета',
    message: 'Вы уверены, что хотите погасить счет?',
    confirmButton: 'Погасить',
    cancelButton: 'Нет',
  },
};
